<template>
  <v-card>
    <v-card-text>
      <h3 class="title font-weight-regular">Browser Stats</h3>
      <h6 class="subtitle-2 font-weight-light">
        Different browsers Used to Visit
      </h6>
      <div
        v-if="isLoading"
        class="d-flex justify-center align-center"
        style="height:400px"
      >
        <v-progress-circular
          :size="50"
          color="primary"
          indeterminate
        ></v-progress-circular>
      </div>
      <div v-if="!isLoading">
        <div class="d-flex align-center pb-3 mt-9">
          <div>
            <img src="@/assets/images/browser/chrome-logo.png" alt="logo" />
          </div>
          <div class="mx-2">Google Chrome</div>
          <v-spacer></v-spacer>
          <div class="ml-auto">
            <v-chip
              class="ma-2"
              small
              label
              color="light-blue lighten-5 info--text"
              >{{ Chrome }}%</v-chip
            >
          </div>
        </div>
        <div class="d-flex align-center pt-2 pb-3">
          <div>
            <img src="@/assets/images/browser/firefox-logo.png" alt="logo" />
          </div>
          <div class="mx-2">Mozila Firefox</div>
          <v-spacer></v-spacer>
          <div class="ml-auto">
            <v-chip
              class="ma-2"
              small
              label
              color="light-green lighten-5 success--text"
              >{{ Firefox }}%</v-chip
            >
          </div>
        </div>
        <div class="d-flex align-center pt-2 pb-3">
          <div>
            <img src="@/assets/images/browser/safari-logo.png" alt="logo" />
          </div>
          <div class="mx-2">Apple Safari</div>
          <v-spacer></v-spacer>
          <div class="ml-auto">
            <v-chip
              class="ma-2"
              small
              label
              color="deep-purple lighten-5 purple--text"
              >{{ Safari }}%</v-chip
            >
          </div>
        </div>
        <div class="d-flex align-center pt-2 pb-3">
          <div>
            <img src="@/assets/images/browser/internet-logo.png" alt="logo" />
          </div>
          <div class="mx-2">Internet Explorer</div>
          <v-spacer></v-spacer>
          <div class="ml-auto">
            <v-chip
              class="ma-2"
              small
              label
              color="yellow lighten-5 warning--text"
              >{{ IE }}%</v-chip
            >
          </div>
        </div>
        <div class="d-flex align-center pt-2 pb-3">
          <div>
            <img src="@/assets/images/browser/opera-logo.png" alt="logo" />
          </div>
          <div class="mx-2">Opera</div>
          <v-spacer></v-spacer>
          <div class="ml-auto">
            <v-chip class="ma-2" small label color="red lighten-5 error--text"
              >{{ Opera }}%</v-chip
            >
          </div>
        </div>
        <div class="d-flex align-center pt-2 pb-3">
          <div>
            <img src="@/assets/images/browser/internet-logo.png" alt="logo" />
          </div>
          <div class="mx-2">Microsoft edge</div>
          <v-spacer></v-spacer>
          <div class="mx-auto">
            <v-chip
              class="ma-2"
              small
              label
              color="light-blue lighten-5 info--text"
              >{{ Edge }}%</v-chip
            >
          </div>
        </div>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: "TheBrowserStats",
  props: ["browserRate", "total"],
  data: () => ({
    isLoading: false,
    Chrome: 0,
    Safari: 0,
    Edge: 0,
    Opera: 0,
    IE: 0,
    Firefox: 0,
    Others: 0
  }),
  watch: {
    browserRate: async function(newVal) {
      this.isLoading = true;
      newVal.forEach(b => {
        this[b.name] =
          this.total != 0 ? Math.round((b.count * 100) / this.total) : 0;
      });
      await this.sleep(1300);
      this.isLoading = false;
    }
  },
  async mounted() {
    this.isLoading = true;
    while (!Array.isArray(this.browserRate)) {
      await this.sleep(10);
    }
    console.log(this.browserRate);
    this.browserRate.forEach(b => {
      this[b.name] =
        this.total != 0 ? Math.round((b.count * 100) / this.total) : 0;
    });
    this.isLoading = false;
  },
  methods: {
    sleep(ms) {
      return new Promise(resolve => setTimeout(resolve, ms));
    }
  }
};
</script>
<style scoped>
@media (min-width: 1264px) {
  .full-height {
    height: 100%;
  }
}
</style>
